import { EBM_RESOURCE_CONFIG_OPTION_META_KEYS } from '../../../capabilities/ebm-nodes/fieldKeys';
import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { EbmSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: EbmSpec) => EbmSpec> = {
  baseInfo: (spec) => ({
    ...spec,
    alias: '',
    description: undefined,
    workspace: undefined,
  }),
  network: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        vpc: undefined,
        subnet: undefined,
        securitygroup: undefined,
      },
    },
  }),
  systemSetting: (spec) => ({
    ...spec,
    runStrategy: undefined,
    systemDisk: undefined,
  }),
  service: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        service: undefined,
      },
    },
  }),
  resource: (spec) => {
    const optionMeta = spec.optionMeta ? { ...spec.optionMeta } : undefined;
    const ebmNodeKey = EBM_RESOURCE_CONFIG_OPTION_META_KEYS.ebmNode;
    if (optionMeta && ebmNodeKey in optionMeta) {
      delete optionMeta[ebmNodeKey];
    }
    return {
      ...spec,
      resourceConfigurationRaw: undefined,
      ...(optionMeta && Object.keys(optionMeta).length ? { optionMeta } : { optionMeta: undefined }),
      resource: {
        ...spec.resource,
        cpu: undefined,
        memory: undefined,
        gpu: undefined,
        storage: undefined,
        network: {
          ...spec.resource.network,
          nic: undefined,
        },
      },
    };
  },
  dns: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        dnsConfig: undefined,
      },
    },
  }),
};

export function isEbmModuleEnabled(moduleKey: string, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}

/** 按 enabledModules 裁剪 spec，防止未选模块泄漏到 preset / apiBody */
export function filterEbmSpecByEnabledModules(
  spec: EbmSpec,
  enabledModules?: Record<string, boolean>,
  skuType?: 'fixed' | 'custom',
): EbmSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}
